export const widthArrMobIOE = ['73%', '20%', '24%'];
export const widthArrIOE = ['73%', '12%', '15%'];
export const columnConfigurationForIOE = [
  {
    columnName: 'Asset Class',
    format: 'string',
    showColumn: true,
    isTotal: true,
    textAlign: 'left',
    isCurrency: false,
    isPercentage: false,
  },
  {
    columnName: '%',
    format: 'string',
    showColumn: true,
    isTotal: true,
    textAlign: 'right',
    isCurrency: false,
    isPercentage: true,
  },
  {
    columnName: '$',
    format: 'string',
    showColumn: false,
    isTotal: false,
    textAlign: 'right',
    isCurrency: true,
    isPercentage: false,
  },
];

export const childRowsColumnConfigForIOE = {
  childRowsParentWidths: ['100%'],
  columnWidths: ['100%'],
  childTableColumnHeadings: ['Investment Name'],
  isHyperlink: [true],
  showChildColumns: [true],
};

export default {
  grey200: '#D6D6D6',
  iron: '#333333',
  lightGreen: '#EFF4E7',
  darkGreen: '#438300',
  sun90: 'rgba(244, 181, 49, 0.9)',
  sun30: 'rgba(244, 181, 49, 0.3)',
  modalBG: '#474747CC',
  grey: '#FAFAFA',
  darkRed: '#E23D28',
  lightRed: '#F8D3CF',
  darkBlue: '#69869A',
  lightBlue: '#EEF7FC',
  lightGrey: '#EAEAEA',
  darkGrey: '#707070',
  oaBlueTint: '#2B4F8E',
  oaBlue: '#002c77',
  oaIceBlue: '#8BBFF3',
};
